import { render } from "./NewDocumentPage.vue?vue&type=template&id=186778c4&scoped=true&ts=true"
import script from "./NewDocumentPage.vue?vue&type=script&lang=ts"
export * from "./NewDocumentPage.vue?vue&type=script&lang=ts"

import "./NewDocumentPage.vue?vue&type=style&index=0&id=186778c4&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186778c4"]])

export default __exports__